<div class="row" style="margin-bottom:15px;">
  <div class="col-md-12" style="text-align:center">
    <input type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)" style="display:none;">
    <button type="button" class="btn btn-success" id="btnUploadFile" (click)="file.click()">Choose File</button>&nbsp;
    <button type="button" class="btn btn-danger" (click)="CallHideModal()">Cancel</button>
  </div>
  <div id="LoadingImagePopup">
    <img src="../../assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
  </div>
  <div class="col-md-12">
    <span class="upload" id="spanProgress" *ngIf="progress > 0">
      {{progress}}%
    </span>
    <span class="upload" id="spanUploadMsg" *ngIf="message">
      {{message}}
    </span>
  </div>
</div>
